<template>
  <div class="container-fluid">
    <footer class="footer">
      <div class="row">
        <div class="col-md-12 footer-copyright text-center">
          <p class="mb-0">Copyright {{ new Date().getFullYear() }} © Voxo theme by pixelstrap</p>
        </div>
      </div>
    </footer>
  </div>
</template>

<script setup></script>

<style></style>
